/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useWizardContext } from '../context/WizardContext';
import SelectionCard from '../SelectionCard';
import { getWizardIcon } from '../icons/wizardIcons';
import type { WizardIconName } from '../icons/wizardIcons';
import type { UserAttribute } from '../types/wizard.types';

interface AttributeOption {
    id: UserAttribute;
    label: string;
    illustrationKey?: WizardIconName;
}

const ATTRIBUTE_OPTIONS: AttributeOption[] = [
    {
        id: 'fourth-grader',
        label: 'Current 4th Grader',
        illustrationKey: 'fourth-grader',
    },
    {
        id: 'permanent-disability',
        label: 'Permanent Disability',
        illustrationKey: 'accessible',
    },
    {
        id: 'gold-star-veteran',
        label: 'Gold Star Family or Veteran',
        illustrationKey: 'gold-star',
    },
    {
        id: 'military-dependent',
        label: 'Active Military or Dependent',
        illustrationKey: 'military',
    },
    {
        id: 'senior',
        label: 'Senior (Age 62+)',
        illustrationKey: 'senior',
    },
    {
        id: 'none',
        label: 'None of the Above',
    },
];

function AttributeSelectionStep() {
    const { selectedAttributes, toggleAttribute } = useWizardContext();

    return (
        <div>
            <p className="wizard-modal__attribute-intro">
                Some passes require identity verification to confirm eligibility.
            </p>
            <div className="wizard-step-cards wizard-step-cards--multi">
                {ATTRIBUTE_OPTIONS.map((option) => (
                    <SelectionCard
                        key={option.id}
                        id={`attribute-${option.id}`}
                        label={option.label}
                        illustration={
                            option.illustrationKey ? (
                                <img src={getWizardIcon(option.illustrationKey)} alt="" />
                            ) : undefined
                        }
                        isSelected={selectedAttributes.includes(option.id)}
                        onSelect={() => toggleAttribute(option.id)}
                    />
                ))}
            </div>
        </div>
    );
}

export default AttributeSelectionStep;
